<footer class="overflow-x-hidden bg-gradient-footer shadow-footer">
  <div class="relative mx-auto max-w-[1200px]">
    <button
      class="relative z-10 flex flex-col w-full items-center justify-center gap-2 border-0 bg-transparent px-0 py-4 text-xs md:text-sm
        md:absolute md:bottom-0 md:right-0 md:h-[42px] md:w-[35%] md:flex-row md:justify-end md:py-1"
      type="button"
      (click)="toggleFooter()"
      [attr.aria-expanded]="!isCollapsed"
      aria-controls="footer-content"
    >
      <span class="text-primary font-semibold">{{ isCollapsed ? 'Mở rộng chân trang' : 'Thu gọn chân trang' }}</span>
      <img
        src="assets/svg/ic-chervon-double-down.svg"
        alt="Arrow Down"
        class="h-4 w-4 transition-transform duration-300 ease-in-out md:h-5 md:w-5"
        [class.rotate-180]="!isCollapsed"
      />
    </button>

    <div class="px-3 py-3 md:px-0 md:pb-[18px] md:pt-7" id="footer-content" *ngIf="!isCollapsed">
      <nav
        class="text-neutral-01 text-[13px] font-medium grid grid-cols-2 gap-x-6 gap-y-4 md:text-sm md:grid-cols-4 md:gap-6"
        aria-label="Footer navigation"
      >
        <div class="flex flex-col gap-[6px] md:gap-2.5">
          <a
            class="hover:text-primary"
            *ngIf="navAboutUs && aboutUsOverviewNav"
            routerLink="{{ '/' + currentLanguage + '/' + navAboutUs.item.linkUrl + '/' + aboutUsOverviewNav.linkUrl }}"
          >
            {{ navAboutUs.item.name || 'Về QLQ Rồng Việt' }}
          </a>
          <a
            class="hover:text-primary"
            *ngIf="navAboutUs && shareholderRelationsNav && catInformationDisclosure"
            routerLink="{{
              '/' +
                currentLanguage +
                '/' +
                navAboutUs.item.linkUrl +
                '/' +
                shareholderRelationsNav.linkUrl +
                '/' +
                catInformationDisclosure.linkUrl
            }}"
          >
            {{ 'INFORMATION_DISCLOSURE' | translate }}
          </a>
          <a
            class="hover:text-primary"
            *ngIf="knowledgeNav && knowledgeNav.children && knowledgeNav.children[0]"
            routerLink="{{ '/' + currentLanguage + '/' + knowledgeNav.item.linkUrl + '/' + knowledgeNav.children[0].item.linkUrl }}"
          >
            {{ knowledgeNav.item.name || 'Kiến thức đầu tư' }}
          </a>
        </div>

        <div class="flex flex-col gap-[6px] md:gap-2">
          <a
            class="hover:text-primary"
            *ngIf="investmentFundsNav && investmentFundsNav.children && investmentFundsNav.children[0]"
            routerLink="{{
              '/' + currentLanguage + '/' + investmentFundsNav.item.linkUrl + '/' + investmentFundsNav.children[0].item.linkUrl
            }}"
          >
            {{ 'INVESTMENT_FUND_MANAGEMENT' | translate }}
          </a>
          <a class="hover:text-primary" *ngIf="portfolioNav" routerLink="{{ '/' + currentLanguage + '/' + portfolioNav.linkUrl }}">
            {{ portfolioNav.name || 'Quản lý danh mục đầu tư' }}
          </a>
          <a class="hover:text-primary" *ngIf="advisoryNav" routerLink="{{ '/' + currentLanguage + '/' + advisoryNav.linkUrl }}">
            {{ advisoryNav.name || 'Tư vấn đầu tư' }}
          </a>
        </div>

        <div class="flex flex-col gap-[6px] md:gap-2">
          <a
            class="hover:text-primary"
            *ngIf="communicationNav && newsNav"
            routerLink="{{ '/' + currentLanguage + '/' + communicationNav.item.linkUrl + '/' + newsNav.linkUrl }}"
          >
            {{ newsNav.name || 'Tin tức' }}
          </a>
          <a class="hover:text-primary" *ngIf="immunitiesNav" routerLink="{{ '/' + currentLanguage + '/' + immunitiesNav.linkUrl }}">
            {{ immunitiesNav.name || 'Quyền miễn trừ' }}
          </a>
          <a class="hover:text-primary" *ngIf="config?.config4" [href]="config.config4" target="_blank" rel="noopener noreferrer">
            {{ 'CAREER_OPPORTUNITIES' | translate }}
          </a>
        </div>

        <div class="flex flex-col gap-[6px] md:gap-2">
          <a
            class="hover:text-primary"
            *ngIf="contactNav && supportNav"
            routerLink="{{ '/' + currentLanguage + '/' + supportNav.item.linkUrl + '/' + contactNav.linkUrl }}"
          >
            {{ contactNav.name || 'Liên hệ' }}
          </a>
          <a
            class="hover:text-primary"
            *ngIf="faqNav && supportNav"
            routerLink="{{ '/' + currentLanguage + '/' + supportNav.item.linkUrl + '/' + faqNav.linkUrl }}"
          >
            {{ faqNav.name || 'Câu hỏi thường gặp' }}
          </a>
          <a
            class="hover:text-primary"
            href="https://outlook.office365.com/owa/calendar/RongVietAssetManagement@RongVietCorp.onmicrosoft.com/bookings/"
            target="_blank"
            rel="noopener noreferrer"
            >{{ 'MAKE_AN_APPOINTMENT' | translate }}</a
          >
        </div>
      </nav>

      <div class="my-4 border-t border-neutral-02"></div>

      <div class="flex flex-col gap-3 md:grid md:grid-cols-2 md:gap-16">
        <div class="flex flex-col gap-3">
          <p class="text-base font-semibold text-primary">
            {{ config?.name || 'Công ty cổ phần Quản lý quỹ Rồng Việt' }}
          </p>
          <p
            class="min-h-10 overflow-hidden text-sm leading-5 [display:-webkit-box] [-webkit-box-orient:vertical] [-webkit-line-clamp:2]"
            [innerHTML]="config?.description"
          ></p>
          <p class="text-sm">
            {{ config?.adress || 'Tầng 8, toà VietDragon số 141 Nguyễn Du, Phường Bến Thành, TP.HCM, VN' }}
          </p>
          <div class="text-sm flex flex-wrap gap-x-4 gap-y-[6px] md:gap-x-6 md:gap-y-2">
            <span class="flex items-center gap-1.5"
              ><img src="assets/svg/ic-phone.svg" alt="Phone" class="inline-block h-4 w-4" />
              {{ config?.hotline || '(+84-28) 38 237 791' }}</span
            >
            <span class="flex items-center gap-1.5"
              ><img src="assets/svg/ic-fax.svg" alt="Fax" class="inline-block h-4 w-4" />
              {{ config?.config0 || '(+84-28) 38 237 792' }}</span
            >
            <span class="flex items-center gap-1.5"
              ><img src="assets/svg/ic-email.svg" alt="Email" class="inline-block h-4 w-4" />
              {{ config?.email || 'info@vdfm.com.vn' }}</span
            >
          </div>
        </div>

        <div>
          <p class="text-sm font-bold mb-3">{{ 'FOLLOW_US' | translate }}</p>
          <div class="mb-8 flex items-center gap-4 md:mb-[18px]">
            <a [href]="config?.linkZalo" target="_blank" rel="noopener noreferrer"
              ><img class="block h-8 w-8" src="assets/svg/ic-zalo.svg" alt="Zalo" loading="lazy"
            /></a>
            <a [href]="config?.linkFB" target="_blank" rel="noopener noreferrer"
              ><img class="block h-8 w-8" src="assets/svg/ic-fb.svg" alt="Facebook" loading="lazy"
            /></a>
            <a [href]="config?.config1" target="_blank" rel="noopener noreferrer"
              ><img class="block h-8 w-8" src="assets/svg/ic-instagram.svg" alt="Instagram" loading="lazy"
            /></a>
            <a [href]="config?.config5" target="_blank" rel="noopener noreferrer"
              ><img class="block h-8 w-8" src="assets/svg/ic-linkedIn.svg" alt="LinkedIn" loading="lazy"
            /></a>
            <a [href]="config?.linkYouTube" target="_blank" rel="noopener noreferrer"
              ><img class="block h-8 w-8" src="assets/svg/ic-youtube.svg" alt="YouTube" loading="lazy"
            /></a>
          </div>
          <label class="mb-3 block text-sm font-bold" for="footer-email">Nhận thông báo qua Email</label>
          <div class="flex">
            <input
              class="max-w-[280px] box-border h-8 w-full rounded-l-md border border-r-0 border-neutral-01 bg-neutral-06 px-2.5 py-1.5"
              id="footer-email"
              type="email"
              placeholder="Email"
              aria-label="Email"
            />
            <button
              class="h-8 rounded-r-md border border-l-0 border-neutral-01 bg-gradient-01 px-3 py-1 text-sm font-normal text-neutral-06"
              type="button"
            >
              ĐĂNG KÝ
              <span class="ml-2 text-base" aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="relative left-1/2 flex w-screen -translate-x-1/2">
      <div
        class="text-sm box-border flex w-full items-center gap-[6px] rounded-tr-[36px] bg-gradient-01 p-3 text-neutral-06 md:w-[60%]
          md:rounded-tr-[42px] md:pl-[max(12px,calc((100vw-1200px)/2))] md:pr-8"
      >
        © VDAM - {{ 'COPYRIGHT' | translate }}
        <span>|</span>
        <a
          class="text-white no-underline"
          *ngIf="termsAndConditionalNav"
          routerLink="{{ '/' + currentLanguage + '/' + termsAndConditionalNav.linkUrl }}"
        >
          {{ termsAndConditionalNav.name || 'Điều khoản sử dụng' }}
        </a>
      </div>
    </div>
  </div>
</footer>
